import $ from 'jquery';

const card = name => {
  $(document).ready(function(){
    
  });
};
export default card;

